import { Link } from "@remix-run/react"
import { useState } from "react"
import { useMediaQuery } from "react-responsive"
import {
  hamburgerMenu,
  mobileNav,
  mobileNavOpen,
  buttonStyle,
  logo,
  stickyHeader,
} from "./header.css"

const MobileHeader = ({ status }: { status?: "Login" | "SignUp" }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <button className={hamburgerMenu} onClick={() => setIsOpen(!isOpen)}>
        ☰
      </button>
      <div className={`${mobileNav} ${isOpen ? mobileNavOpen : ""}`}>
        <Link to="/">Home</Link>
        <Link to="/articles">Articles & Insights</Link>
        <Link to="/garden-design-guide">Garden Design Guide</Link>
        <Link to="/article/contemporary-garden-ideas-with-rescape-ai">Tutorial</Link>
        {status === "SignUp" && (
          <Link to="/hello/signup" className={buttonStyle}>
            Sign up
          </Link>
        )}
        {status === "Login" && (
          <Link to="/hello/login" className={buttonStyle}>
            Log in
          </Link>
        )}
      </div>
    </>
  )
}

function DesktopHeader({ status = "SignUp" }: { status?: "Login" | "SignUp" }) {
  return (
    <nav className={`${stickyHeader}`}>
      <img src="/logo-sml.png" alt="Rescape AI" className={logo} />
      <Link to="/">Home</Link>
      <Link to="/articles">Articles & Insights</Link>
      <Link to="/article/contemporary-garden-ideas-with-rescape-ai">Tutorial</Link>
      <Link to="/garden-design-guide">Garden Design Guide</Link>
      <span style={{ marginLeft: "auto" }}>
        {status === "SignUp" && (
          <Link to="/hello/signup" className={buttonStyle}>
            Sign up
          </Link>
        )}
        {status === "Login" && (
          <Link to="/hello/login" className={buttonStyle}>
            Log in
          </Link>
        )}
      </span>
    </nav>
  )
}

const StickyHeader = (props: { status?: "Login" | "SignUp" }) => {
  const isBigger = useMediaQuery({
    query: "(min-width: 768px)",
  })

  if (isBigger) {
    return <DesktopHeader {...props} />
  }

  return <MobileHeader {...props} />
}

export default StickyHeader
